module.exports = __webpack_public_path__ + "static/highway-purple-95044d02f39183ff62ec5b7e2d6ec045.png";